module.exports = __webpack_public_path__ + "img/context_icon.34430864.svg";